<template>
  <TableList
    v-rect-loading="loading"
    class="company-policy-list"
    row-key="id"
    hideOnClick
    :createBtnLabel="$t(`${i18nPrefix}.btn.addNewVersion`)"
    :titleI18nKey="$route.meta.titleI18nKey"
    :listData="policyList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    @create="handleClickAdd"
  >
    <template #status="{ row }">
      <el-switch v-model="row.enabled" @change="handleUpdatePolicy(row)"></el-switch>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { createI18nProperty } from '@/i18n'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.agreement',
      policyList: [],
      companyId: null,
      rootCompanyId: null
    }
  },
  computed: {
    tableColumns () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.createTime`),
          dataKey: 'created_time'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.policyCreator`),
          dataKey: 'created_by'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.policyOpenStatus`),
          dataKey: 'status',
          slotName: 'status'
        }
      ]
    },
    actionBtn () {
      return {
        edit: {
          show: (rowData) => !rowData.has_enabled,
          onclick: this.handleEditBtnClick,
          labelI18nKey: `${this.i18nPrefix}.btn.editPolicy`
        },
        view: {
          // show: true,
          onclick: this.handleViewBtnClick,
          labelI18nKey: `${this.i18nPrefix}.btn.viewPolicy`
        }
      }
    }
  },
  created () {
    this.loadPolicyList()
  },
  methods: {
    ...mapActions('agreement', ['getCompanyPolicyList', 'updateCompanyPolicy', 'deleteCompanyPolicy']),
    async loadPolicyList () {
      this.loading = true
      try {
        const resp = await this.getCompanyPolicyList()
        if (resp) {
          this.companyId = resp.company
          this.rootCompanyId = resp.root_company
          this.policyList = _.forEach(resp.policies, policy => {
            if (policy.type === 'LINK') {
              createI18nProperty(policy, 'typeName', `${this.i18nPrefix}.label.statementPreview`)
            } else if (policy.type === 'POPUP') {
              createI18nProperty(policy, 'typeName', `${this.i18nPrefix}.label.statementPop`)
            }
          })
        }
      } finally {
        this.loading = false
      }
    },
    async handleUpdatePolicy (row) {
      const policyInfo = {
        policy_id: row.id,
        enabled: row.enabled,
        update_enabled: true
      }
      this.loading = true
      try {
        const resp = await this.updateCompanyPolicy({
          policyId: row.id,
          policyInfo
        })
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.updateEnabled`))
          _.forEach(this.policyList, (policy) => {
            policy.enabled = false
          })
          row.enabled = true
          row.has_enabled = true
        }
      } finally {
        this.loading = false
      }
    },
    handleClickAdd () {
      this.$router.push({ path: '/v-admin/company-policy-management/add', query: { rootCompanyId: this.rootCompanyId, companyId: this.companyId } })
    },
    handleViewBtnClick (row) {
      this.$router.push({ path: `/v-admin/company-policy-management/view/${row.id}`, query: { type: row.type } })
    },
    handleEditBtnClick (row) {
      this.$router.push({ path: `/v-admin/company-policy-management/edit/${row.id}`, query: { type: row.type, rootCompanyId: this.rootCompanyId, companyId: this.companyId } })
    },
    handleDeleteBtnClick (row) {
      this.$confirm(this.$t(`${this.i18nPrefix}.message.deleteOrNot`), this.$t(`${this.i18nPrefix}.message.deletePoint`), {
        confirmButtonText: this.$t(`${this.i18nPrefix}.btn.confirm`),
        cancelButtonText: this.$t(`${this.i18nPrefix}.btn.cancel`),
        type: 'warning'
      }).then(() => {
        this.deleteCompanyPolicy(row.id).then(response => {
          if (response) {
            this.loadPolicyList()
            this.$message({
              type: 'success',
              message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
            })
          }
        }).catch(() => {
          this.$message({
            type: 'wanning',
            message: this.$t(`${this.i18nPrefix}.message.deleteFail`)
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t(`${this.i18nPrefix}.message.deleteCancel`)
        })
      })
    }
  },
  watch: {
    '$route' () {
      this.loadPolicyList()
    }
  }
}

</script>

<style lang='scss' scoped>
.policy-tos-list {
  .policy-tos-table {
    .add-policy-btn {
      text-align: right;

      .add-btn {
        border-color: #0096cc;
        font-size: 12px;
        font-weight: bold;
        color: #FFFFFF;
        background: #0096CC;
      }
    }

    .el-table {
      margin-top: 22px;
      border-color: #b2b5b7;

      &::before, &::after {
        background-color: #b2b5b7;
      }

      ::v-deep {
        th {
          background-color: #ddd;
          color: #626365;
          font-size: 12px;
          font-weight: normal;
        }

        th,
        th.is-leaf,
        th.el-table__cell.is-leaf,
        td,
        td.el-table__cell {
          border-color: #b2b5b7;
          text-align: center;
        }

        td {
          padding: 0;
        }

        .cell {
          word-break: keep-all;
        }
      }
    }
  }
}
</style>
